// A plan drawn as the checklist it is (SUN-1346; Fabien chose this layout
// from three), moved from today's Code tab (code/PlanBlock.tsx there): its
// name, how far it is, and every step on a row with its state. What runs now
// stands out; what is done steps back; what is still to come is faint. The
// words are the agent's own, as it wrote them: in a reply (plan.ts), or in
// ACP's `plan` update, which names no plan.
import { CheckIcon } from '../components/Icons'
import { cx } from './bits'
import { StepNowIcon, StepTodoIcon } from './icons'
import type { Plan, StepState } from './plan'

const SAID: Record<StepState, string> = { done: 'Done', now: 'Now', todo: 'To do' }

export function PlanBlock({ plan }: { plan: Plan }) {
  const { name, done, total, steps } = plan
  const share = total > 0 ? Math.min(1, Math.max(0, done / total)) : 0
  const labelled = steps.some((step) => step.label !== undefined)
  return (
    <section className="code-plan" aria-label={`Plan${name ? `: ${name}` : ''}, ${done} of ${total} steps done`}>
      <header className="code-plan-head">
        <span className="code-plan-tag">Plan</span>
        {name && <span className="code-plan-name">{name}</span>}
        <span className="code-plan-count">
          {done} / {total}
        </span>
        {total > 0 && (
          <span className="progress-track code-plan-track" aria-hidden="true">
            <span className="progress-fill" style={{ width: `${share * 100}%` }} />
          </span>
        )}
      </header>
      {steps.length > 0 && (
        <ol className={cx('code-plan-steps', labelled && 'is-labelled')}>
          {steps.map((step, at) => (
            <li key={at} className={`code-plan-step is-${step.state}`}>
              <span className="code-plan-mark" aria-hidden="true">
                {step.state === 'done' ? <CheckIcon size={14} /> : step.state === 'now' ? <StepNowIcon size={14} /> : <StepTodoIcon size={14} />}
              </span>
              <span className="visually-hidden">{`${SAID[step.state]}: `}</span>
              {labelled && <span className="code-plan-label">{step.label}</span>}
              <span className="code-plan-text">{step.text}</span>
            </li>
          ))}
        </ol>
      )}
    </section>
  )
}
